export default  {
    bindings: {
        source: '<',
        type: '@',
        formTab: '='
    },
    controller: 'relatedFormController',
    template: require('../views/related.form.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/related.form.component.js